<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h4 v-if="client && client.key && site && site.key" class="p-d-flex p-ai-baseline">
                    <router-link icon="pi pi-angle-left" class="p-button p-button-icon p-mr-4" v-if="client && client.key"
                        :to="{ name: 'site', params: { client_id: client.key, id: site.key } }">
                        <i class="pi pi-angle-left"></i>
                        Back
                    </router-link>
                    <span>
                        <router-link :to="{ name: 'sites', params: { id: client.key } }">{{ client.name }}</router-link> /
                        <router-link :to="{ name: 'site', params: { client_id: client.key, id: site.key } }">{{ site.name
                        }}</router-link> /
                        Notes
                    </span>
                </h4>

                <TabView>
                    <TabPanel header="Notes">
                        <div class="p-d-flex p-jc-end p-mb-2" v-if="siteNotes.length > 5">
                            <Button label="New Note" icon="pi pi-plus" class="p-button-secondary"
                                @click="note = {}; editingNote = true" iconPos="right" />
                        </div>
                        <Panel :header="format_date(siteNote.timestamp)"
                            v-for="siteNote in orderBy(siteNotes, 'timestamp', -1)" :key="siteNote.id" class="p-mb-3">
                            <div v-if="siteNote.type == 'text' || siteNote.type == 'task'">
                                <p v-html="siteNote.content.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2')"></p>
                            </div>

                            <div v-if="siteNote.type == 'photo'">
                                <img style="max-width: 200px;max-height: 200px;" :src="siteNote.content" />
                            </div>

                            <p v-if="siteNote.type == 'checklist'">
                                <span v-for="(content, index) in siteNote.content" :key="index">
                                    <span v-if="index > 0 && index <= siteNote.content.length"> | </span>
                                    <span>{{ content.name }}</span>
                                    <b v-if="content.complete == true"> - Complete </b>
                                    <b v-if="content.complete == false"> - Complete </b>
                                </span>
                            </p>
                        </Panel>
                        <div v-if="siteNotes.length < 1">
                            <p class="p-jc-center">There are 0 notes assigned to this site yet. Click a 'New Note' to add a
                                note.</p>
                        </div>

                        <div class="p-d-flex p-jc-end">
                            <Button label="New Note" icon="pi pi-plus" class="p-button-secondary"
                                @click="note = {}; editingNote = true" iconPos="right" />
                                <Dialog :visible.sync="editingNote">
                                <template #header>
                                    <h3>Add Note</h3>
                                </template>

                                <Textarea class="note__area" v-model="note.content" rows="5" cols="30" />

                                <template #footer>
                                    <Button label="Cancel" icon="pi pi-times" class="p-button-text"
                                        @click="note = {}; editingNote = false" />
                                    <Button label="Save" icon="pi pi-check" @click="addEditNote(note)" />
                                </template>
                            </Dialog>
                        </div>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    </div>
</template>

<script>
import { db } from '@/firebase';
import Vue2Filters from 'vue2-filters';
import moment from 'moment';

export default {
    props: ['user'],
    mixins: [Vue2Filters.mixin],
    data() {
        return {
            client: {},
            site: {},
            siteNotes: [],
            siteTasks: [],
            editingNote: false,
            selected: {
                name: '',
            },
            displayConfirmation: false,
            note: {
                content: '',
            },
        }
    },
    firestore() {
        return {
            siteNotes: db.collection('notes').where('client_id', '==', this.$route.params.client_id).where('site_id', '==', this.$route.params.id),
            notes: db.collection('notes'),
            site: db.collection('sites').doc(this.$route.params.id),
            client: db.collection('clients').doc(this.$route.params.client_id),
        }
    },
    methods: {
        format_date(value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY @ HH:mm')
            }
        },
        createTask() {
            const task = {
                timestamps: {
                    created: Date.now()
                },
                name: this.selected.name,
                site_id: this.site.key,
                status: 'active',
            }
            this.$firestore.tasks.add(task).then(() => {
                this.selected.name = '';
                this.visibleRight = false;
                db.collection('logs').add({
                    activity: 'New task created',
                    timestamp: new Date(),
                    user: this.user.email,
                    client_id: this.user.client.key,
                    site: this.site.name
                }).then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Success', detail: 'New task created', life: 3000 });
                });
            });
        },
        addEditNote: function (note) {
            if (note.key) {
                this.$firestore.notes.doc(note.key).update({ 'content': this.note.content }).then(() => {
                    this.editingNote = false;
                    db.collection('logs').add({
                        activity: 'Note updated',
                        timestamp: new Date(),
                        user: this.user.email,
                        client_id: this.user.client.key,
                        site: this.site.name
                    }).then(() => {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Note updated', life: 3000 });
                    });
                });
            } else {
                this.$firestore.notes.add({ 'site_id': this.site.key, 'client_id': this.$route.params.client_id, 'type': 'text', 'content': note.content, 'timestamp': Date.now() }).then(() => {
                    this.editingNote = false;
                    db.collection('logs').add({
                        activity: 'Note added',
                        timestamp: new Date(),
                        user: this.user.email,
                        client_id: this.user.client.key,
                        site: this.site.name
                    }).then(() => {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Note added', life: 3000 });
                    });
                });
            }
        },
        updateTaskStatus(status, task) {
            let value = status == null ? 'active' : status;
            this.$firestore.tasks.doc(task.key).update({ 'status': value, timestamps: { 'complete': Date.now() } }).then(() => {
                db.collection('logs').add({
                    activity: 'Task Status Updated - ' + value.charAt(0).toUpperCase() + value.slice(1),
                    timestamp: new Date(),
                    user: this.user.email,
                    client_id: this.user.client.key,
                    site: this.site.name
                }).then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Task Status Updated - ' + value.charAt(0).toUpperCase() + value.slice(1), life: 3000 });
                });
            });
        },
    }
}
</script>

<style scoped lang="scss">
.p-datatable-row-expansion {
    td {
        padding: 0;
    }
}

.note__area {
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
